import type { AlertWindowFire } from './alert-window-types'

/** Local HH:mm:ss of an ISO timestamp. */
export function formatMatchTime(iso: string): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleTimeString('en-GB', { hour12: false })
}

/** Newest first; ties keep the larger event id first so a burst reads in arrival order. */
export function newestFirst(fires: AlertWindowFire[]): AlertWindowFire[] {
  return [...fires].sort((a, b) => {
    const t = Date.parse(b.matched_at) - Date.parse(a.matched_at)
    return t !== 0 ? t : b.event_id.localeCompare(a.event_id)
  })
}
